import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { CarDetailsQueryKeys } from "modules/CarDetails/queryKeys";
import { ApiInstance } from "utils/Api";

export const useDeleteTyresMutation = () => {
  const { t } = useTranslation();

  const { mutate, isPending } = useTypedMutation<number, void>({
    mutationFn: async car_id => {
      await ApiInstance.post("/tyres/storage_set/remove", { car_id }, ENV.carBaseURL);
    },
    onSuccess: () => {
      const car = typedQueryClient.getQueryData(CarDetailsQueryKeys.details);
      if (!car) return;

      typedQueryClient.setQueryData(CarDetailsQueryKeys.details, { ...car, in_storage_tyres: undefined });
    }
  });

  const openPortalDBB = async (appointmentId?: number) => {
    if (!appointmentId) return;

    try {
      const res = await ApiInstance.post("/dbb/portal", { id: appointmentId });
      window.open(res.data.url, "_blank");
    } catch (err) {
      toast.error(t("v8_error", "Something went really wrong "));
      throw err;
    }
  };

  return { mutate, isPending, openPortalDBB };
};
